export default {
  reduceVisibleBy: 3,
};
